import { config } from '../config';
import axios from 'axios';
const currentVersion = '1.0';

export function getFeatureFlags() {
  return axios.get(
    `${config.core.featureFlagServiceUrl}/v${currentVersion}/feature-flags`
  );
}
